import type { ReactNode } from 'react';
import { Navbar } from '../Navbar';
import Footer from '../Footer';

interface PageLayoutProps {
  pageTitle: string;
  children: ReactNode;
  showFooter?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  pageTitle,
  children,
  showFooter = true,
}) => (
  <div className="min-h-screen flex flex-col">
    <Navbar pageTitle={pageTitle} showDivider={true} />
    <main className="flex-1 px-4 sm:px-6 lg:px-8 py-8 pt-24">
      <div className="max-w-7xl mx-auto w-full">{children}</div>
    </main>
    {showFooter && <Footer />}
  </div>
);
